import { useState, useEffect } from "react";
import { useRouter } from "next/compat/router";

export function usePrice() {
  const router = useRouter();

  const [locale, setLocale] = useState(null);

  useEffect(() => {
    setLocale(router?.locale);
  }, [router?.locale]);

  return (amount, options = {}) => {
    const { withoutCents, withoutSpace } = options;

    const amntEuro = amount / 100;
    const amntIsInteger = Number.isInteger(amntEuro);
    const amntShortened =
      amntIsInteger && withoutCents ? Math.floor(amntEuro).toFixed(0) : amntEuro.toFixed(2);
    const finalAmount = amntShortened.replace(".", ",");

    if (!locale) return null;

    switch (locale) {
      case "nl":
      case "en":
        return `€${finalAmount}`;
      default:
        return `${finalAmount}${withoutSpace ? "" : "\u00A0"}€`;
    }
  };
}
